export default "__VITE_ASSET__d63a7415__"